import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {getFormData} from "../../models/customerModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {customerSchema} from "../../schema/customerSchema";
import {createCustomer} from "../../store/customer-slice";

const CustomerAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        createStatus,
        error
    } = useSelector(state => state.customer);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        // Convert empty floor to undefined
        if (data.address?.floor === '') {
            data.address.floor = undefined;
        }

        dispatch(createCustomer({
            ...userRole,
            data: data
        }));
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const schema = customerSchema(); // Updated schema
    const initialData = getFormData(); // Now from employee model
    return (
        <>
            <SubHeader title="Add Customer">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
export default CustomerAdd;
